<template>
  <div>
    <vue-advanced-chat height="100vh" :current-user-id="currentUserId" :rooms="JSON.stringify(rooms)"
      :message-actions="[]" :rooms-loaded="true" :rooms-list-opened="false" :show-add-room="false" :show-search="false"
      :show-audio="false" :show-files="false" :messages="JSON.stringify(messages)" :messages-loaded="messagesLoaded"
      :show-new-messages-divider="false" @send-message="sendMessage($event.detail[0])"
      @fetch-messages="fetchMessages($event.detail[0])" ref="vacRef" single-room :show-send-icon="loadingMessages"
      :text-messages="JSON.stringify(textMessages)" :auto-scroll="JSON.stringify(scrolls)">
      <div slot="room-header" class="room-header">
        <img :src="rooms[0].avatar" alt="Room Avatar" class="room-avatar" />
        <div class="room">
          <div class="room-info">
            <h3>{{ rooms[0].roomName }}</h3>
          </div>
          <div class="room-action">
            <i :class="`fa fa-trash delete-button ` + (chatId == null ? `disable` : ``)" @click="deleteChat"></i>
          </div>
        </div>
      </div>
      <div v-if="optionMessage" :key="optionMessage._id" :slot="'message_' + optionMessage._id">
        <div v-if="optionMessage.customType === 'options' && optionMessage.options" class="message-options">
          <p>{{ optionMessage.content }}</p>
          <div class="options-buttons">
            <button v-for="option in optionMessage.options" :key="option.value" @click="handleOptionClick(option)">
              {{ option.label }}
            </button>
          </div>
        </div>
      </div>
    </vue-advanced-chat>
  </div>
</template>

<script>

import { ref, onMounted } from 'vue'
import { register } from 'vue-advanced-chat'
register()

import { WebChatHistory, Questions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { ElMessage } from "element-plus";
import { encryptData, decryptData } from "@/utils/crypto"

// Or if you used CDN import
// window['vue-advanced-chat'].register()

export default {

  setup() {
    const vacRef = ref(null)
    const addCustomStyle = () => {
      if (!vacRef.value) return
      const style = document.createElement('style')
      style.textContent = `
        #roomTextarea::placeholder{
            color: #888888; 
            opacity: 1;
        }

        .vac-text-started{
          display:none !important
        }

        .vac-messages-container{
          padding-top: 10px !important;
        }

        
      `
      vacRef.value.shadowRoot.appendChild(style)
    }

    onMounted(() => {
      addCustomStyle()
    })
    return {
      vacRef,
      addCustomStyle
    }
  },

  data() {
    return {
      store: useStore(),
      scrolls: {
        send: {
          new: true, newAfterScrollUp: true
        },
        receive: {
          new: true, newAfterScrollUp: true
        }
      },
      messagesLoaded: false,
      loadingMessages: false,
      currentUserId: '1234',
      questions: [],
      rooms: [
        {
          roomId: '',
          roomName: 'Trợ lý ảo',
          avatar: 'media/logos/test/favicon.png',
          unreadCount: 0,
          index: 1,
          users: [
            {
              _id: '1234',
              username: 'Người dùng',
            },
            {
              _id: '4321',
              username: 'Trợ lý ảo',
            }
          ],
          typingUsers: [4321]
        }
      ],
      messages: [],
      roomActions: [
      ],
      chatId: null,
      textMessages: {
        NEW_MESSAGES: 'Tin nhắn mới',
        MESSAGE_DELETED: 'Tin nhắn đã bị xóa',
        MESSAGES_EMPTY: 'Tin nhắn trống',
        CONVERSATION_STARTED: 'Bắt đầu cuộc trò chuyện:',
        TYPE_MESSAGE: 'Nhập tin nhắn...',
        SEARCH: 'Tìm kiếm',
        IS_ONLINE: 'Đang online',
        LAST_SEEN: 'Lần cuối thấy ',
        IS_TYPING: 'Đang nhập',
        CANCEL_SELECT_MESSAGE: 'Hủy chọn tin nhắn',
      },
      encryptedData: null,
    }
  },
  computed: {
    optionMessage() {
      if (this.messages.length == 1) {
        return this.messages[0]
      } else {
        return false
      }
    }
  },
  methods: {
    async getQuestions() {
      try {
        const res = await this.store.dispatch(Questions.listQuestions, { pageSize: 5, pageNum: 1 })
        if (res.code === 200) {
          this.questions = res.data.content.map((item) => ({
            label: item.cCauHoi,
            value: item.nMaCauHoi,
            answer: item.cCauTraLoi,
          }))
        } else {
          ElMessage.error('Lỗi khi tải câu hỏi')
        }
      } catch (error) {
        console.error('Error fetching questions:', error)
        ElMessage.error('Lỗi khi tải câu hỏi')
      }
    },

    async fetchMessages({ options = {} }) {
      setTimeout(async () => {
        if (localStorage.getItem('chatId')) {
          this.chatId = localStorage.getItem('chatId')

          this.store.dispatch(WebChatHistory.getWebChatHistoryById, this.chatId).then((response) => {
            if (response.code === 200) {
              const decryptedData = decryptData(response.msg)
              const content = JSON.parse(decryptedData.content)
              this.messages = content.message
              this.rooms[0] = content.room
              localStorage.setItem('chatId', this.chatId)
            } else {
              ElMessage.error('Lỗi khi tải tin nhắn')
            }
          }).catch((error) => {
            console.error('Error fetching messages:', error)
            ElMessage.error('Lỗi khi tải tin nhắn')
          })
          this.messagesLoaded = true
          this.loadingMessages = true
        } else {
          await this.getQuestions()
          this.messages = [
            {
              _id: 1,
              content: 'Xin chào tôi có thể giúp gì cho bạn?',
              senderId: '4321',
              /* timestamp: new Date().toString().substring(16, 21),
              date: new Date().toDateString(), */
              type: 'custom',
              customType: 'options',
              options: this.questions
            }
          ]
          this.messagesLoaded = true
          this.loadingMessages = true
        }
      })
    },
    sendMessage(message) {
      this.loadingMessages = false
      this.messages = [
        ...this.messages.map(val => { return { ...val } })
      ]
      if (message.length != undefined) {
        this.messages.push({
          ...message[0],
          _id: this.messages.length,
        })
        this.messages.push({
          ...message[1],
          _id: this.messages.length,
        })
        this.loadingMessages = true
      } else {
        this.messages.push({
          _id: this.messages.length,
          content: message.content,
          senderId: this.currentUserId,
          seen: false,
        })
      }
      this.rooms[0].unreadCount = 0
      const messageData = {
        id: this.chatId,
        content: JSON.stringify({ room: this.rooms[0], message: this.messages }),
      }
      this.messages.push({
        _id: this.messages.length,
        content: "Trợ lý ảo đang xử lý tin nhắn của bạn...",
        senderId: "4321",
        seen: false,
      })
      const encryptedData = encryptData(messageData)
      this.store.dispatch(WebChatHistory.saveWebChatHistory, encryptedData).then((response) => {
        if (response.code === 200) {
          const decryptedData = decryptData(response.data)
          const content = JSON.parse(decryptedData.content)
          this.messages = content.message
          this.rooms[0] = content.room
          localStorage.setItem('chatId', decryptedData.id)
          this.chatId = decryptedData.id
        } else {
          ElMessage.error('Lỗi khi gửi tin nhắn')
        }
        this.loadingMessages = true
      }).catch((error) => {
        ElMessage.error('Lỗi khi gửi tin nhắn')
        this.loadingMessages = true
      })
    },
    handleOptionClick(option) {
      this.sendMessage(
        [
          {
            _id: this.messages.length,
            content: option.label,
            senderId: this.currentUserId,
            seen: false,
          },
          {
            _id: this.messages.length + 1,
            content: this.convertHtmlToMarkdown(option.answer),
            senderId: "4321",
            seen: false,
          },
        ])
    },
    async deleteChat() {
      await this.getQuestions()
      if (this.chatId && isNaN(this.chatId)) {
        this.rooms[0].unreadCount = 0
        this.chatId = localStorage.removeItem('chatId')
        this.messages = []
        this.messages.push(
          {
            _id: 1,
            content: 'Xin chào tôi có thể giúp gì cho bạn?',
            senderId: '4321',
            type: 'custom',
            customType: 'options',
            options: this.questions
          }
        )
        this.messagesLoaded = true
        this.loadingMessages = true
      } else
        this.store.dispatch(WebChatHistory.deleteWebChatHistory, this.chatId).then((response) => {
          if (response.code === 200) {
            ElMessage.success('Xóa lịch sử chat thành công')
            this.rooms[0].unreadCount = 0
            localStorage.removeItem('chatId')
            this.chatId = null
            this.messages = []
            this.messages.push(
              {
                _id: 1,
                content: 'Xin chào tôi có thể giúp gì cho bạn?',
                senderId: '4321',
                type: 'custom',
                customType: 'options',
                options: this.questions
              }
            )
          } else {
            ElMessage.error('Lỗi khi xóa lịch sử chat')
          }
        }).catch((error) => {
          console.error('Error deleting chat:', error)
          ElMessage.error('Lỗi khi xóa lịch sử chat')
        })
    },
    convertHtmlToMarkdown(html) {
      html = html.replace(/<(strong|b)>(.*?)<\/\1>/gi, '**$2**');
      html = html.replace(/<(em|i)>(.*?)<\/\1>/gi, '*$2*');
      html = html.replace(/<p>(.*?)<\/p>/gi, '$1\n');
      html = html.replace(/<ol>(.*?)<\/ol>/gis, (_, inner) => {
        const listItems = inner.match(/<li>(.*?)<\/li>/gi);
        if (!listItems) return '';
        return listItems.map((item, index) => {
          const content = item.replace(/<\/?li>/gi, '');
          return `${index + 1}. ${content}`;
        }).join('\n') + '\n\n';
      });

      // Convert unordered lists
      html = html.replace(/<ul>(.*?)<\/ul>/gis, (_, inner) => {
        const listItems = inner.match(/<li>(.*?)<\/li>/gi);
        if (!listItems) return '';
        return listItems.map(item => `- ${item.replace(/<\/?li>/gi, '')}`).join('\n') + '\n\n';
      });

      // Remove any remaining HTML tags
      html = html.replace(/<\/?[^>]+(>|$)/g, '');
      // Trim whitespace
      return html.trim();
    }

  }
}
</script>
<style scoped>
.message-options {
  background-color: #fff;
  padding: 10px;
  border-radius: 10px;
}

.options-buttons button {
  margin: 5px;
  padding: 5px 10px;
  border-radius: 5px;
  cursor: pointer;
  border: 1px solid #0b9e49;
  background-color: #fff;
  text-align: left;
}

.options-buttons button:hover {
  background-color: #ddd;
}

.room-header {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 20px;
  background-color: #0b9e49;
}

.room-avatar {
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  background-color: #ddd;
  height: 42px;
  width: 42px;
  min-height: 42px;
  min-width: 42px;
  margin-right: 15px;
  border-radius: 50%;
}

.room {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.room-info {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.room-info h3 {
  color: #fff;
  margin-bottom: 0;
}

.delete-button {
  font-size: 20px;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
}

.delete-button:hover {
  font-size: 22px;
  color: #ff4d4f;
}

.delete-button.disable {
  color: #ddd;
  cursor: not-allowed;
  pointer-events: none;
}
</style>